/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Templatedefault1Inputs */

const en_entity_templatedefault1 = /** @type {(inputs: Entity_Templatedefault1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Default`)
};

const de_entity_templatedefault1 = /** @type {(inputs: Entity_Templatedefault1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template-Standard`)
};

/**
* | output |
* | --- |
* | "Template Default" |
*
* @param {Entity_Templatedefault1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_templatedefault1 = /** @type {((inputs?: Entity_Templatedefault1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Templatedefault1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_templatedefault1(inputs)
	return de_entity_templatedefault1(inputs)
});
export { entity_templatedefault1 as "entity_templateDefault" }